import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { resolveOAuthRedirectUri } from '../util/oauth-hub.util';

@Component({
    selector: 'app-microsoft-callback',
    template: '<p>Procesando autenticación de Microsoft...</p>',
    standalone: false
})
export class MicrosoftCallbackComponent implements OnInit {
    /** Origin del tenant que inició el login (viene en el state). */
    private tenantOrigin = '';

    constructor(private route: ActivatedRoute, private http: HttpClient) {}

    ngOnInit() {
        const code = this.route.snapshot.queryParamMap.get('code');
        const rawState = this.route.snapshot.queryParamMap.get('state') || '';
        const [, tenantOrigin] = rawState.split('|');
        this.tenantOrigin = tenantOrigin || window.location.origin;

        if (!code) {
            this.postToOpener({ type: 'MICROSOFT_OAUTH_ERROR', error: 'No code received' });
            return;
        }

        // Debe coincidir EXACTO con el redirect_uri enviado a Microsoft (el hub).
        const redirectUri = resolveOAuthRedirectUri('microsoft-callback');

        this.http.post(`${environment.apiUrl}/common/auth/microsoft-exchange`, { code, redirect_uri: redirectUri })
            .subscribe({
                next: (resp: any) => {
                    const data = resp.result || resp;
                    this.postToOpener({
                        type: 'MICROSOFT_OAUTH_SUCCESS',
                        provider_id: data.provider_id,
                        email: data.email,
                        name: data.name
                    });
                },
                error: () => {
                    this.postToOpener({ type: 'MICROSOFT_OAUTH_ERROR', error: 'Exchange failed' });
                }
            });
    }

    private postToOpener(data: any) {
        if (window.opener) {
            // Postear al origin del tenant que abrió el popup (viene en el state).
            window.opener.postMessage(data, this.tenantOrigin || window.location.origin);
            setTimeout(() => window.close(), 500);
        }
    }
}
